module.exports = __webpack_public_path__ + "img/pimg55.63d56fa3.png";